'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlocksItem = function () {
  function BlocksItem(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, BlocksItem);

    this.els = {
      el: el,
      image: (0, _functional.getElement)('.sec-BlocksItem_Image', { context: el })
    };

    this.lFollowX = 0;
    this.lFollowY = 0;
    this.x = 0;
    this.y = 0;
    this.friction = 1 / 25;

    this.animate = this.animate.bind(this);
    this.isAnimating = false;

    this.els.el.addEventListener('mousemove', function (e) {
      var lMouseX = Math.max(-100, Math.min(100, _this.els.el.offsetWidth / 2 - (e.pageX - (0, _utils.getOffsetLeft)(_this.els.el))));
      var lMouseY = Math.max(-100, Math.min(100, _this.els.el.offsetHeight / 2 - (e.pageY - (0, _utils.getOffsetTop)(_this.els.el))));

      _this.lFollowX = 20 * lMouseX / 100;
      _this.lFollowY = 20 * lMouseY / 100;
    });

    if (window.innerWidth >= _utils.mediaBreakpoints.lg) {
      this.animate();
    }

    var resizeFnc = function resizeFnc() {
      if (window.innerWidth < _utils.mediaBreakpoints.lg && _this.isAnimating) {
        window.cancelAnimationFrame(_this.raf);
        _this.isAnimating = false;
      } else if (window.innerWidth >= _utils.mediaBreakpoints.lg && _this.isAnimating === false) {
        _this.animate();
      }
    };
    window.addEventListener('resize', (0, _utils.debounce)(resizeFnc, 50));
  }

  (0, _createClass3.default)(BlocksItem, [{
    key: 'animate',
    value: function animate() {
      this.x += (this.lFollowX - this.x) * this.friction;
      this.y += (this.lFollowY - this.y) * this.friction;

      var translate = 'translate(' + this.x + 'px, ' + this.y + 'px) scale(1.1)';

      this.els.image.style.transform = translate;

      this.isAnimating = true;
      this.raf = window.requestAnimationFrame(this.animate);
    }
  }]);
  return BlocksItem;
}();

exports.default = BlocksItem;